import React from "react";
import { useSelector } from "react-redux";
import styles from "./EmptyState.module.css";
import { CustomButton, CustomTooltip, icon, IconComponent } from "../../../../../../common/components";
import { translate } from "../../../../../../common/providers";

const EmptyState = ({ hasActionPermission, isGenerating, onClick }) => {
	const hasAvailableAIQuota = useSelector(({ context }) => context?.hasAvailableAIQuota);
	return (
		<div className={styles.container}>
			<div>
				<IconComponent
					color="var(--blue-500)"
					icon={isGenerating ? icon.faSpinner : icon.faWandMagic}
					spin={isGenerating}
				/>
			</div>
			<div className={styles.innerContainer}>
				<div className={styles.title}>
					{isGenerating
						? translate("dashboards.project.project-summary.empty-state.generating.title")
						: translate("dashboards.project.project-summary.empty-state.empty.title")}
				</div>
				<div className={styles.description}>
					{isGenerating
						? translate("dashboards.project.project-summary.empty-state.generating.description")
						: translate("dashboards.project.project-summary.empty-state.empty.description")}
				</div>
				{!isGenerating && hasActionPermission && (
					<CustomTooltip
						title={
							(!hasAvailableAIQuota && translate("common:company.quotas.consumption-reached.tooltip")) ||
							""
						}
					>
						<span>
							<CustomButton disabled={!hasAvailableAIQuota} variant="contained" onClick={onClick}>
								{translate("dashboards.project.project-summary.empty-state.empty.lauch-generation")}
							</CustomButton>
						</span>
					</CustomTooltip>
				)}
			</div>
		</div>
	);
};

export default EmptyState;
